import { useRef, useEffect } from 'react';
import flatpickr from 'flatpickr';
import "flatpickr/dist/flatpickr.min.css"; // Importa el CSS

/**
 * Componente para seleccionar una fecha usando flatpickr.
 * * @param {string} initialDate - La fecha inicial en formato 'YYYY-MM-DD'.
 * @param {function} onDateChange - Función de callback que recibe la nueva fecha.
 */
const DatePicker = ({ initialDate, onDateChange }) => {
  const inputRef = useRef(null);

  useEffect(() => {
    // Inicializa flatpickr en el elemento input
    const fp = flatpickr(inputRef.current, {
      dateFormat: "Y-m-d", // Formato de fecha
      defaultDate: initialDate,
      onChange: (selectedDates, dateStr, instance) => {
        // Llama a la función de cambio de fecha con la nueva fecha seleccionada
        if (selectedDates.length > 0) {
          onDateChange(dateStr);
        }
      }
    });

    // Limpia al desmontar el componente
    return () => {
      fp.destroy();
    };
  }, [onDateChange]); // La función onDateChange debe ser estable (ej: envuelta en useCallback)

  // Actualiza la fecha por defecto si la prop initialDate cambia
  useEffect(() => {
    if (inputRef.current && inputRef.current._flatpickr) {
      inputRef.current._flatpickr.setDate(initialDate, false);
    }
  }, [initialDate]);

  return (
    <div className="input-group   input-group-text justify-content-end bg-dark border-0 ">
      <span className="input-group-text bg-dark text-light px-2 py-1 border-secondary" id=""><i className="bi bi-calendar-event"></i></span>
      <input 
        ref={inputRef} 
        type="text" 
        placeholder="Select date" 
        className='text-center bg-dark text-light'
      />
    </div>
  );
};

export default DatePicker;